import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanchganicab() {



    const cardData = {

keyword: "Pune to Panchgani Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Panchgani Cab services for family trips, weekend getaways, and hill station tours. We provide well-maintained Sedan, SUV, Innova Crysta, and Tempo Traveller options with experienced chauffeurs for smooth and scenic travel through the Sahyadri hills. With doorstep pickup across Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, we ensure a peaceful and enjoyable journey to the beautiful hill station of Panchgani.",

topPlaces: [
    {
        title: "Table Land Plateau",
        description:
            "Table Land is the second-largest mountain plateau in Asia and the most famous attraction in Panchgani. It offers vast open landscapes, horse riding, panoramic valley views, and stunning sunrise and sunset points. It is a must-visit spot for families, couples, and nature lovers visiting Panchgani."
    },
    {
        title: "Sydney Point",
        description:
            "Sydney Point is a scenic viewpoint offering breathtaking views of the Krishna Valley, Dhom Dam, and surrounding hills. It is especially popular during sunrise and sunset, providing a peaceful atmosphere and perfect photography opportunities for tourists."
    },
    {
        title: "Parsi Point",
        description:
            "Parsi Point is a famous viewpoint known for its wide valley views and cool breeze. It offers beautiful sights of Krishna Valley and is a popular picnic spot for families and groups traveling from Pune to Panchgani."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a popular tourist attraction located between Panchgani and Mahabaleshwar, known for strawberry farms, fresh fruit products, chocolates, and food stalls. Visitors can enjoy strawberry picking, juices, and garden experiences."
    },
    {
        title: "Devrai Art Village",
        description:
            "Devrai Art Village is an artistic space in Panchgani showcasing handmade metal art and sculptures created by local tribal artists. It promotes eco-friendly art and provides a unique cultural experience for visitors."
    },
    {
        title: "Rajpuri Caves",
        description:
            "Rajpuri Caves are ancient natural caves surrounded by water tanks and believed to have mythological significance. It is a peaceful spiritual and historical site located close to Panchgani."
    },
    {
        title: "Dhom Dam",
        description:
            "Dhom Dam is located near Panchgani and offers scenic views of water surrounded by hills. It is a peaceful spot ideal for photography, relaxation, and enjoying nature away from crowded tourist areas."
    },
    {
        title: "Panchgani Strawberry Farms",
        description:
            "Panchgani is famous for its strawberry farms where visitors can experience fresh fruit picking, farm tours, and local produce. It is a highlight of the region, especially during the strawberry season."
    },
    {
        title: "Bhilar Village (Book Village)",
        description:
            "Bhilar Village is known as India’s first ‘Book Village’, where houses are converted into reading spaces. It offers a unique cultural experience combining literature, art, and rural tourism near Panchgani."
    },
    {
        title: "Wai Temples & Krishna River",
        description:
            "Wai is a historic town near Panchgani known for ancient temples and the Krishna River ghats. It is often visited during Pune to Panchgani cab trips for its cultural and scenic significance."
    }
],



services: [
{
name: "Pune to Panchgani Taxi Fare",
description: "Rising Cab Service offers Pune to Panchgani Taxi Fare packages with transparent pricing, professional drivers, and comfortable AC vehicles. Whether you are planning a family vacation, weekend getaway, sightseeing tour, or business trip, we provide safe and reliable transportation from Pune to Panchgani. Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, and Urbania vehicles. Enjoy doorstep pickup, well-maintained vehicles, flexible travel schedules, online booking support, and affordable rates for one-way and round-trip journeys."
},
{
name: "Pune to Panchgani Cab",
description: "Rising Cab Service offers Pune to Panchgani Cab service with clean AC vehicles, experienced chauffeurs, and affordable pricing. Whether you are traveling for tourism, family vacations, corporate travel, or weekend trips, we provide comfortable and reliable transportation with doorstep pickup, flexible scheduling, and online booking facilities."
},
{
name: "Pune Airport to Panchgani Taxi Fare",
description: "Rising Cab Service offers Pune Airport to Panchgani Taxi Fare services with direct airport pickup, comfortable AC vehicles, and professional drivers. Whether you are arriving from another city or planning a holiday trip, we ensure smooth and hassle-free transportation with transparent pricing and reliable service."
},
{
name: "Pune to Panchgani Cab Fare",
description: "Rising Cab Service provides Pune to Panchgani Cab Fare packages with transparent pricing and comfortable travel options. Our services are suitable for families, tourists, couples, and groups seeking a safe and affordable journey to Panchgani with experienced drivers and clean vehicles."
},
{
name: "Pune to Panchgani Distance by Taxi Fare",
description: "Book Pune to Panchgani Distance by Taxi Fare service with Rising Cab Service and enjoy a comfortable road trip with professional chauffeurs. We offer customized travel packages, flexible pickup locations, and a variety of vehicle options to suit your travel requirements."
},
{
name: "Pune to Panchgani Ertiga Cab",
description: "Rising Cab Service offers Pune to Panchgani Ertiga Cab for families and small groups seeking spacious and comfortable travel. The vehicle provides ample luggage space, air-conditioned comfort, and a smooth ride for sightseeing and holiday trips."
},
{
name: "Pune to Panchgani Taxi",
description: "Choose Pune to Panchgani Taxi service from Rising Cab Service for safe and convenient travel. We provide well-maintained vehicles, trained drivers, affordable pricing, and 24x7 customer support for local and outstation travel needs."
},
{
name: "Pune to Panchgani Taxi Distance",
description: "Rising Cab Service provides Pune to Panchgani Taxi Distance travel packages designed for comfortable and stress-free transportation. Our fleet includes multiple vehicle options suitable for solo travelers, families, and groups."
},
{
name: "Pune To Panchgani Taxi",
description: "Book Pune To Panchgani Taxi with Rising Cab Service and enjoy reliable transportation, clean vehicles, and professional chauffeur service. We ensure timely pickups, safe travel, and comfortable journeys for every customer."
},
{
name: "Pune to Panchgani Drop Taxi",
description: "Rising Cab Service offers Pune to Panchgani Drop Taxi for one-way travel requirements. Our service is ideal for travelers seeking affordable drop-only transportation with professional drivers and comfortable vehicles."
},
{
name: "Innova Cab Pune to Panchgani",
description: "Book Innova Cab Pune to Panchgani for premium comfort and spacious travel. Ideal for families and group travelers, our Innova vehicles offer comfortable seating, ample luggage space, and smooth highway performance."
},
{
name: "Innova Crysta Cab Pune to Panchgani",
description: "Rising Cab Service offers Innova Crysta Cab Pune to Panchgani with luxury interiors, comfortable seating, and premium travel experience. Perfect for family vacations, corporate travel, and tourist outings."
},
{
name: "Ertiga Cab Pune to Panchgani",
description: "Choose Ertiga Cab Pune to Panchgani for economical and comfortable travel. Our vehicles are ideal for small groups and families looking for affordable transportation with professional drivers."
},
{
name: "Dzire Cab Pune to Panchgani",
description: "Book Dzire Cab Pune to Panchgani for budget-friendly travel with AC comfort, clean interiors, and experienced chauffeurs. Suitable for solo travelers, couples, and business trips."
},
{
name: "Sedan Cab Pune to Panchgani",
description: "Rising Cab Service provides Sedan Cab Pune to Panchgani with affordable fares and comfortable seating. Enjoy a smooth and reliable travel experience with our professionally managed cab services."
},
{
name: "SUV Cab Pune to Panchgani",
description: "Hire SUV Cab Pune to Panchgani for spacious and comfortable travel. Our SUV fleet is suitable for group travel, family vacations, and hill station trips with excellent road performance."
},
{
name: "Luxury Cab Pune to Panchgani",
description: "Experience premium travel with Luxury Cab Pune to Panchgani. Our luxury vehicles provide superior comfort, stylish interiors, and professional chauffeur service for a memorable journey."
},
{
name: "Tempo Traveller Pune to Panchgani",
description: "Book Tempo Traveller Pune to Panchgani for group tours, family vacations, corporate outings, and sightseeing trips. Enjoy spacious seating, AC comfort, and ample luggage space throughout the journey."
},
{
name: "Urbania on Rent Pune to Panchgani",
description: "Rising Cab Service offers Urbania on Rent Pune to Panchgani for luxury group travel. The premium vehicle provides comfortable seating, modern interiors, air conditioning, and a smooth travel experience."
},
{
name: "Pune to Panchgani Cab Service",
description: "Rising Cab Service provides Pune to Panchgani Cab Service with reliable vehicles, experienced drivers, and affordable pricing. We ensure safe and comfortable transportation for all types of travelers."
},
{
name: "Pune to Panchgani Taxi Service",
description: "Choose Pune to Panchgani Taxi Service for convenient travel with doorstep pickup, AC vehicles, flexible schedules, and professional chauffeurs. We offer one-way and round-trip options."
},
{
name: "Pune to Panchgani Cab Booking",
description: "Pune to Panchgani Cab Booking is available with instant confirmation, transparent pricing, and multiple vehicle choices. Book easily and enjoy a hassle-free travel experience."
},
{
name: "Pune to Panchgani Taxi Booking",
description: "Rising Cab Service offers Pune to Panchgani Taxi Booking with online reservation support, professional drivers, and affordable travel packages for individuals, families, and groups."
},
{
name: "Pune to Panchgani One Way Cab",
description: "Book Pune to Panchgani One Way Cab for economical drop-only transportation. Our service provides reliable travel with clean vehicles, experienced drivers, and transparent fares."
},
{
name: "Pune to Panchgani One Way Taxi",
description: "Rising Cab Service offers Pune to Panchgani One Way Taxi for travelers looking for convenient and budget-friendly transportation with comfortable AC vehicles and professional service."
},
{
name: "Pune to Panchgani Taxi Price",
description: "Get the best Pune to Panchgani Taxi Price with Rising Cab Service. We provide affordable rates, multiple vehicle options, and reliable transportation for every travel requirement."
},
{
name: "Pune to Panchgani Cab Hire",
description: "Pune to Panchgani Cab Hire offers customized travel packages, professional chauffeur service, and flexible vehicle options for sightseeing, vacations, and business trips."
},
{
name: "Pune to Panchgani Taxi Hire",
description: "Choose Pune to Panchgani Taxi Hire for comfortable and dependable transportation. We provide clean vehicles, trained drivers, and competitive pricing for local and outstation travel."
},
{
name: "Pune to Panchgani Outstation Cab",
description: "Rising Cab Service offers Pune to Panchgani Outstation Cab with comfortable vehicles, safe driving practices, and affordable fares for long-distance travel and weekend getaways."
},
{
name: "Pune to Panchgani Outstation Taxi",
description: "Book Pune to Panchgani Outstation Taxi for a stress-free journey with experienced drivers, AC comfort, and reliable transportation support throughout your trip."
},
{
name: "Pune to Panchgani Drop Cab",
description: "Pune to Panchgani Drop Cab service is ideal for one-way travel requirements. Enjoy economical pricing, professional drivers, and comfortable transportation with Rising Cab Service."
},
{
name: "Pune to Panchgani Drop Taxi",
description: "Rising Cab Service provides Pune to Panchgani Drop Taxi with affordable fares, timely pickups, and comfortable vehicles for seamless one-way travel."
},
{
name: "Pune to Panchgani Cab Online Booking",
description: "Pune to Panchgani Cab Online Booking allows quick reservations, instant confirmation, and multiple vehicle choices. Enjoy convenient booking and reliable travel support."
},
{
name: "Pune to Panchgani Taxi Online Booking",
description: "Book Pune to Panchgani Taxi Online Booking with Rising Cab Service and enjoy hassle-free reservations, transparent pricing, and comfortable travel arrangements."
},
{
name: "Pune to Panchgani Cab for Trip",
description: "Rising Cab Service offers Pune to Panchgani Cab for Trip packages designed for sightseeing, family holidays, group tours, and weekend travel with comfortable vehicles and professional chauffeurs."
},
{
name: "Pune to Panchgani Hill Station Cab",
description: "Book Pune to Panchgani Hill Station Cab for a scenic and comfortable journey to one of Maharashtra's most popular hill stations. Enjoy safe travel, flexible schedules, and premium service."
}
],

tableData: [
["Pune to Panchgani Taxi Fare","Pune to Panchgani Cab"],
["Pune Airport to Panchgani Taxi Fare","Pune to Panchgani Cab Fare"],
["Pune to Panchgani Distance by Taxi Fare","Pune to Panchgani Ertiga Cab"],
["Pune to Panchgani Taxi","Pune to Panchgani Taxi Distance"],
["Pune To Panchgani Taxi","Pune to Panchgani Drop Taxi"],
["Innova Cab Pune to Panchgani","Innova Crysta Cab Pune to Panchgani"],
["Ertiga Cab Pune to Panchgani","Dzire Cab Pune to Panchgani"],
["Sedan Cab Pune to Panchgani","SUV Cab Pune to Panchgani"],
["Luxury Cab Pune to Panchgani","Tempo Traveller Pune to Panchgani"],
["Urbania on Rent Pune to Panchgani","Pune to Panchgani Cab Service"],
["Pune to Panchgani Taxi Service","Pune to Panchgani Cab Booking"],
["Pune to Panchgani Taxi Booking","Pune to Panchgani One Way Cab"],
["Pune to Panchgani One Way Taxi","Pune to Panchgani Taxi Price"],
["Pune to Panchgani Cab Hire","Pune to Panchgani Taxi Hire"],
["Pune to Panchgani Outstation Cab","Pune to Panchgani Outstation Taxi"],
["Pune to Panchgani Drop Cab","Pune to Panchgani Drop Taxi"],
["Pune to Panchgani Cab Online Booking","Pune to Panchgani Taxi Online Booking"],
["Pune to Panchgani Cab for Trip","Pune to Panchgani Hill Station Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Panchgani Cab Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Panchgani cab transportation for families, couples, tourists, students, and weekend travelers seeking a refreshing hill station getaway."
    },
    {
        WhyChooseheading: "Perfect for Hill Station Vacations",
        WhyChoosedescription: "Panchgani is famous for its pleasant climate, scenic valleys, strawberry farms, viewpoints, and peaceful surroundings, making it a favorite destination near Pune."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Travel",
        WhyChoosedescription: "Customers can choose one-way transfers, same-day return trips, weekend holidays, overnight stays, and customized Panchgani travel packages."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Urbania, and Mini Buses based on your group size and travel preferences."
    },
    {
        WhyChooseheading: "Explore Famous Panchgani Attractions",
        WhyChoosedescription: "Visit Table Land, Sydney Point, Parsi Point, Mapro Garden, Devil's Kitchen, Rajpuri Caves, and other popular sightseeing destinations."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Cab pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Ghat Road Travel",
        WhyChoosedescription: "Our professional drivers are experienced in hill station routes and ensure safe, smooth, and comfortable journeys."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Groups",
        WhyChoosedescription: "Whether planning a family vacation, honeymoon, corporate outing, school trip, or weekend getaway, our Panchgani cab service is the perfect travel solution."
    }
]
};

const faqData = [
    {
        question: "Why is Panchgani a popular tourist destination?",
        answer: "Panchgani is known for its scenic viewpoints, pleasant weather, strawberry farms, Table Land, and beautiful valley views."
    },
    {
        question: "Can I book a one-way cab from Pune to Panchgani?",
        answer: "Yes, one-way and round-trip cab services are available according to customer requirements."
    },
    {
        question: "Can Panchgani and Mahabaleshwar be covered in the same trip?",
        answer: "Yes, most travelers combine Panchgani and Mahabaleshwar sightseeing in a single travel package."
    },
    {
        question: "Which vehicle is best for a family trip to Panchgani?",
        answer: "Ertiga and Innova Crysta are popular choices for families due to their spacious seating and comfortable travel experience."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers, Urbania, and Mini Buses are available for large families, school groups, and corporate outings."
    },
    {
        question: "Can I book a same-day Panchgani trip from Pune?",
        answer: "Yes, same-day sightseeing and return packages are available for Panchgani and nearby attractions."
    },
    {
        question: "Is Panchgani suitable for weekend vacations?",
        answer: "Yes, Panchgani is one of the most popular weekend getaway destinations near Pune."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickup services are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "Can I customize my Panchgani sightseeing itinerary?",
        answer: "Yes, customers can customize sightseeing locations and travel schedules according to their preferences."
    },
    {
        question: "How can I book a Pune to Panchgani Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Aditya Patil",
        feedback:
            "Our family trip to Panchgani was wonderful. The cab was clean, comfortable, and the driver guided us to all the major sightseeing locations.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Snehal Kulkarni",
        feedback:
            "We booked a cab for a weekend getaway to Panchgani and Mahabaleshwar. The journey was smooth, scenic, and perfectly managed from start to finish.",
        rating: 5
    }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Panchgani Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-panchgani-cab.jpg",
"description": "Book Pune to Panchgani Cab with Rising Cab Service for comfortable hill station travel. Ideal for family trips, weekend getaways, and sightseeing to Table Land, Sydney Point, and Parsi Point with safe AC cars and experienced drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-panchgani-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Panchgani Cab Service | Hill Station Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Panchgani Cab for safe and comfortable hill station travel. Visit Table Land, Sydney Point, and Parsi Point with affordable AC taxi service."
/>

<meta
 name="keywords"
 content="pune to panchgani cab fare, pune to panchgani taxi fare, pune to panchgani cab charges, pune to panchgani taxi rates, pune airport to panchgani taxi, pune to panchgani distance, panchgani cab booking pune, panchgani hill station cab pune, pune to panchgani sightseeing cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetopanchganicab;